import noop from 'lodash/noop';
import autobind from 'class-autobind';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import ModalLinkCreator from 'zoomforth_shared_management/components/modal_link_creator.jsx';
import ModalLinkSharer from 'zoomforth_shared_management/components/modal_link_sharer.jsx';
import RequestApprovalMessageModal from './request_approval_message.jsx';
import LinkInactivePendingApprovalModal from './link_inactive_pending_approval_modal.jsx';

import withBackboneListeners from 'zoomforth_zfutils/with_backbone_listeners.jsx';

const CHANGE_APPROVAL_CREATING_STATE = 'CHANGE_APPROVAL_CREATING_STATE';
const CHANGE_APPROVAL_SENT_STATE = 'CHANGE_APPROVAL_SENT_STATE';

/**

  Capture the logic of the entirety of the page publish flow in this component

*/
class PagePublishFlow extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // If this publish flow will cause the page to "Go Live",
      // e.g., previously the page was not externally accessible, and after
      // this publish it will be. We need to perform some actions.
      isGoingLive: this.getHasNoLinks(),
      // Its possible a route will be created during this process,
      // if so we store that route as state and will display the share modal
      createdRoute: null,
      changeApprovalState: null
    };

    autobind(this);
  }

  getHasNoLinks() {
    return this.props.pageRoutes.length == 0;
  }

  getUserHasPermissionToViewPagePrivacy() {
    return this.props.user.getPermissions().canChangeVisitorAccessSettings();
  }

  getUserHasPermissionToPublish() {
    return this.props.user.getPermissions().canPublish(this.props.page);
  }

  getIsApprovalPending() {
    return this.props.page.get('approval_pending');
  }

  componentDidMount() {

    if (!this.getHasNoLinks()) {
      // If this page already has links then we skip directly to the
      // publishing flow
      this.publishOrStartChangeApproval();
    }

  }

  publishOrStartChangeApproval() {
    
    if (this.getUserHasPermissionToPublish()) {
      this.props.onPublish();
      if (!this.state.createdRoute) {
        this.handleComplete();
      }

    } else {
      this.setState({
        changeApprovalState: CHANGE_APPROVAL_CREATING_STATE
      });
    }
  }

  handleLinkCreate(route) {
    this.setState({
      createdRoute: route
    });
    this.props.onRouteCreate(route);
    this.publishOrStartChangeApproval();
  }

  handleChangeApprovalMessageCreate(message) {
    this.props.onChangeApprovalMessageCreate(message);
    this.setState({
      changeApprovalState: CHANGE_APPROVAL_SENT_STATE
    });
  }

  handleComplete() {
    if (this.state.isGoingLive && this.getUserHasPermissionToViewPagePrivacy()) {
      this.props.onVisitorAccessSettingsReviewSuggest();
    }
    this.props.onRequestClose();
  }

  render() {

    const {
      createdRoute,
      changeApprovalState
    } = this.state;

    const {
      page,
      domains,
      onVisitorAccessSettingsView,
      onViewLinksClick,
      onSubscribeToRouteClick,
      onRequestClose
    } = this.props;

    return (
      this.getHasNoLinks() ?
        <ModalLinkCreator
          page={page}
          domains={domains}
          closeOnOuterClick={false}
          onRequestClose={onRequestClose}
          onRouteCreate={this.handleLinkCreate}
          onVisitorAccessSettingsView={()=> {
            onRequestClose();
            onVisitorAccessSettingsView();
          }}
          onViewLinksClick={()=> {
            onRequestClose();
            onViewLinksClick();
          }}
          onSubscribeToRouteClick={(routeId)=> {
            onRequestClose();
            onSubscribeToRouteClick(routeId);
          }}
        />

      : changeApprovalState === CHANGE_APPROVAL_CREATING_STATE ?
        <RequestApprovalMessageModal 
          onCancel={onRequestClose}
          onConfirm={this.handleChangeApprovalMessageCreate}
        />

      : createdRoute ?

        ( changeApprovalState == CHANGE_APPROVAL_SENT_STATE ?

          <LinkInactivePendingApprovalModal
            onRequestClose={this.handleComplete}
          />

        : 

          <ModalLinkSharer
            page={page}
            canCreateNewLink={false}
            urlToShare={createdRoute.get('url')}
            routeIdToShare={createdRoute.id}
            onVisitorAccessSettingsView={()=> { 
              this.handleComplete();
            }}
            onRequestClose={this.handleComplete} 
            onCreateNewLinkClick={noop}
            onViewAllLinksClick={()=> {
              this.handleComplete();
              onViewLinksClick();
            }}
          />
        )

      :

        null

    );
  }
}



PagePublishFlow.propTypes = {
  page: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  pageRoutes: PropTypes.object.isRequired,
  onPublish: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onRouteCreate: PropTypes.func.isRequired,
  onVisitorAccessSettingsView: PropTypes.func.isRequired,
  onVisitorAccessSettingsReviewSuggest: PropTypes.func.isRequired,
  onViewLinksClick: PropTypes.func.isRequired,
  onSubscribeToRouteClick: PropTypes.func.isRequired
};


export default withBackboneListeners(
  PagePublishFlow,
  { 
    page: 'change',
    pageRoutes: 'add remove reset' 
  }
);
